module.exports = __webpack_public_path__ + "static/media/hourglass.81f09894.svg";